/* dialog.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt"];
import "./dialog.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box } from '@atlaskit/primitives/compiled';
var imageStyles = null;
var actionItemContainerStyles = {
  root: "_1e0c1txw _2lx21sbv _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr"
};
var actionItemStyles = {
  root: "_6rthze3t _1pfhze3t _12l21b66 _ahbq1b66"
};

/**
 * __Dialog image__
 *
 * An optional header image in spotlight dialogs.
 *
 * @internal
 */
export var DialogImage = function DialogImage(_ref) {
  var alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("img", _extends({
    alt: alt
  }, props, {
    className: ax(["_p12f1osq _4t3i1wug"])
  }));
};

/**
 * __Dialog action item container__
 *
 * Flex wrapper around dialog action items.
 *
 * @internal
 */
export var DialogActionItemContainer = function DialogActionItemContainer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: actionItemContainerStyles.root
  }, children);
};

/**
 * __Dialog action item__
 *
 * Action items shown inside of the dialog.
 *
 * @internal
 */
export var DialogActionItem = function DialogActionItem(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: actionItemStyles.root
  }, children);
};